const getNamespacedName = (namespace, name) => {
  const pieces = Array.isArray(namespace) ? [...namespace] : namespace ? [namespace] : [];
  pieces.push(name);

  return pieces.join('/');
};

export default getNamespacedName;



// WEBPACK FOOTER //
// ./src/store/utils/getNamespacedName.js